// Frames by Model & Colour (67_ModelColor.jsx — task #96 report 2, from the Order Status master, 31/10/2026).
const en = {
  nav: 'Frames by Model & Colour',
  title: 'Frames by Model & Colour',
  sub: 'Frames shipped overseas (finished products) by model and frame colour — the Total Frame sheet of Sales Team 1\'s "Overseas sales by Model and Color".',
  excel: 'Excel',
  upload: 'Upload Order Status',
  reading: 'Reading the file…',
  readingLong: 'Reading the Order Status master — about half a minute for a 20 MB file.',
  uploaded: 'Order Status read: {{n}} rows, S/D {{from}} → {{to}}.',
  source: 'Counted from: {{file}} — uploaded {{at}} by {{by}}, {{n}} rows, S/D up to {{to}}.',
  noSource: 'No Order Status file uploaded yet — the years show the workbook\'s numbers only.',
  byYear: 'By year',
  oneMonth: 'One month',
  sheet: 'Sheet',
  legend: 'Up to Sep 2026: the workbook\'s own numbers. From {{from}} the months are counted from the uploaded Order Status, S/D up to today (marked +OS; click a number marked on its left edge to see the order lines).',
  checkTitle: 'The four line sheets add up to Total Frame:',
  countedHint: 'Includes months counted from the Order Status',
  countedCell: '{{n}} of it counted from the Order Status — click to see the lines',
  linesYearNote: 'Only the part counted from the Order Status (from Oct 2026); the rest of the year is the workbook\'s number.',
  model: 'Model',
  color: 'Colour',
  frameColor: 'Frame colour',
  total: 'Total',
  month: 'Month',
  beforeNote: 'This month is before Oct 2026: the workbook already has it. Shown here is what the uploaded Order Status says today — S/D dates may have moved since.',
  none: 'Nothing shipped.',
  lines: 'Lines',
  year: 'Year',
  dashboard: 'Dashboard',
  other: 'Other',
  dToDate: '{{y}} so far',
  dTotal: 'Frames shipped',
  dTopColour: 'Top frame colour',
  dTopModel: 'Top model',
  dYoy: '{{a}} vs {{b}}',
  dByYear: 'Frames by colour, year by year (pcs)',
  dLatestFive: 'The latest five of the years picked: {{a}} – {{b}}.',
  dTop3: 'Top 3 frame colours in {{y}}',
  dStack: 'Frames per colour, by model (pcs, the years picked)',
  sourceShort: 'Order Status uploaded {{at}} · S/D up to {{to}} — how the numbers are made',
  checkOk: 'four lines = Total Frame',
  all: 'All',
  seeLines: 'Click to see the order lines',
  someLinesNote: 'Not all four lines picked: every year is counted from the uploaded Order Status (S/D up to today), because the workbook has frame colours only for the four lines together. With all four, the years are the workbook\'s own.',
  soFarNote: 'This month is not over: shipped so far, S/D up to {{d}}. Later S/D dates in the Order Status are planned shipments and are not counted.',
  buyer: 'Buyer',
  nLines: '{{n}} line(s)',
  loading: 'Loading…',
  close: 'Close',
};

const ko = {
  nav: '모델·색상별 프레임',
  title: '모델·색상별 프레임',
  sub: '해외 출고 프레임(완제품), 라인·모델·색상별 — Sales Team 1의 "Overseas sales by Model and Color".',
  excel: 'Excel',
  upload: 'Order Status 업로드',
  reading: '파일 읽는 중…',
  readingLong: 'Order Status 파일을 읽는 중이에요 — 20MB 파일은 30초 정도 걸려요.',
  uploaded: 'Order Status 읽음: {{n}}행, S/D {{from}} → {{to}}.',
  source: '집계 기준: {{file}} — {{at}} {{by}} 업로드, {{n}}행, S/D {{to}}까지.',
  noSource: '아직 Order Status 파일이 없어요 — 연도별 숫자는 엑셀 파일 숫자만 보여요.',
  byYear: '연도별',
  oneMonth: '한 달',
  sheet: '시트',
  legend: '2026년 9월까지는 엑셀 파일의 숫자예요. {{from}}부터는 업로드한 Order Status에서 오늘까지의 S/D로 집계해요(+OS 표시, 왼쪽에 표시된 숫자를 누르면 주문 행이 보여요).',
  checkTitle: '라인 시트 4개의 합 = Total Frame:',
  countedHint: 'Order Status에서 집계한 달이 포함돼요',
  countedCell: '이 중 {{n}}개는 Order Status에서 집계 — 눌러서 행 보기',
  linesYearNote: 'Order Status에서 집계한 부분(2026년 10월부터)만 보여요. 나머지는 엑셀 파일 숫자예요.',
  model: '모델',
  color: '색상',
  frameColor: '프레임 색상',
  total: '합계',
  month: '월',
  beforeNote: '2026년 10월 이전 달이라 엑셀 파일에 이미 있어요. 여기는 지금 업로드된 Order Status 기준이에요 — 그 뒤로 S/D 날짜가 바뀌었을 수 있어요.',
  none: '출고 없음.',
  lines: '라인',
  year: '연도',
  dashboard: '대시보드',
  dToDate: '{{y}}년은 진행 중',
  other: '기타',
  dTotal: '출고 프레임',
  dTopColour: '최다 프레임 색상',
  dTopModel: '최다 모델',
  dYoy: '{{a}} vs {{b}}',
  dByYear: '프레임 색상별 연도 추이 (개)',
  dLatestFive: '고른 연도 중 최근 5년: {{a}} – {{b}}.',
  dTop3: '{{y}}년 상위 3 프레임 색상',
  dStack: '색상별 프레임, 모델별 (개, 고른 연도)',
  sourceShort: 'Order Status 업로드 {{at}} · S/D {{to}}까지 — 숫자 산출 방법',
  checkOk: '라인 4개 = Total Frame',
  all: '전체',
  seeLines: '눌러서 주문 행 보기',
  someLinesNote: '네 라인을 모두 고르지 않았어요: 모든 연도를 업로드한 Order Status(오늘까지의 S/D)로 집계해요. 엑셀 파일에는 네 라인 합계의 프레임 색상만 있어요. 네 라인을 모두 고르면 엑셀 파일 숫자가 보여요.',
  soFarNote: '아직 끝나지 않은 달이에요: {{d}}까지의 S/D만 집계해요. Order Status의 이후 S/D는 출고 예정이라 빠져요.',
  buyer: '바이어',
  nLines: '{{n}}행',
  loading: '불러오는 중…',
  close: '닫기',
};

const vi = {
  nav: 'Frame theo model & màu',
  title: 'Frame theo model & màu',
  sub: 'Số frame đã ship đi nước ngoài (thành phẩm) theo model và màu frame — sheet Total Frame trong file "Overseas sales by Model and Color" của Sales Team 1.',
  excel: 'Excel',
  upload: 'Upload Order Status',
  reading: 'Đang đọc file…',
  readingLong: 'Đang đọc file Order Status — file 20 MB mất khoảng nửa phút.',
  uploaded: 'Đã đọc Order Status: {{n}} dòng, S/D {{from}} → {{to}}.',
  source: 'Đang tính từ: {{file}} — upload lúc {{at}} bởi {{by}}, {{n}} dòng, S/D tới {{to}}.',
  noSource: 'Chưa có file Order Status — các năm chỉ hiện số trong file Excel.',
  byYear: 'Theo năm',
  oneMonth: 'Một tháng',
  sheet: 'Sheet',
  legend: 'Tới tháng 9/2026 là số trong file Excel. Từ {{from}} các tháng được tính từ file Order Status đã upload, S/D tới hôm nay (nhãn +OS; bấm vào số có vạch màu bên trái để xem từng dòng đơn).',
  checkTitle: 'Tổng 4 sheet line = Total Frame:',
  countedHint: 'Có các tháng tính từ Order Status',
  countedCell: 'Trong đó {{n}} tính từ Order Status — bấm để xem các dòng',
  linesYearNote: 'Chỉ phần tính từ Order Status (từ 10/2026); phần còn lại của năm là số trong file Excel.',
  model: 'Model',
  color: 'Màu',
  frameColor: 'Màu frame',
  total: 'Tổng',
  month: 'Tháng',
  beforeNote: 'Tháng này trước 10/2026 nên file Excel đã có. Ở đây là số theo file Order Status đang upload — ngày S/D có thể đã đổi sau đó.',
  none: 'Không có hàng ship.',
  lines: 'Line',
  year: 'Năm',
  dashboard: 'Dashboard',
  other: 'Khác',
  dToDate: '{{y}} chưa hết năm',
  dTotal: 'Số frame đã ship',
  dTopColour: 'Màu frame nhiều nhất',
  dTopModel: 'Model nhiều nhất',
  dYoy: '{{a}} so với {{b}}',
  dByYear: 'Frame theo màu, từng năm (cái)',
  dLatestFive: '5 năm gần nhất trong các năm đang chọn: {{a}} – {{b}}.',
  dTop3: 'Top 3 màu frame năm {{y}}',
  dStack: 'Frame theo màu, chia theo model (cái, các năm đang chọn)',
  sourceShort: 'Order Status upload ngày {{at}} · S/D tới {{to}} — cách tính số',
  checkOk: '4 line = Total Frame',
  all: 'Tất cả',
  seeLines: 'Bấm để xem các dòng đơn',
  someLinesNote: 'Đang không chọn đủ 4 line: mọi năm được tính từ file Order Status đã upload (S/D tới hôm nay), vì file Excel chỉ có màu frame cho cả 4 line gộp lại. Chọn đủ 4 line thì các năm là số của file Excel.',
  soFarNote: 'Tháng này chưa hết: chỉ tính hàng có S/D tới {{d}}. Các ngày S/D sau đó trong Order Status là lịch ship dự kiến nên chưa tính.',
  buyer: 'Buyer',
  nLines: '{{n}} dòng',
  loading: 'Đang tải…',
  close: 'Đóng',
};

const zh = {
  nav: '按型号与颜色的框架',
  title: '按型号与颜色的框架',
  sub: '海外出货的框架（成品），按产品线、型号和颜色 — Sales Team 1 的 "Overseas sales by Model and Color"。',
  excel: 'Excel',
  upload: '上传 Order Status',
  reading: '正在读取文件…',
  readingLong: '正在读取 Order Status 文件 — 20 MB 的文件约需半分钟。',
  uploaded: '已读取 Order Status：{{n}} 行，S/D {{from}} → {{to}}。',
  source: '统计来源：{{file}} — {{at}} 由 {{by}} 上传，{{n}} 行，S/D 至 {{to}}。',
  noSource: '尚未上传 Order Status 文件 — 年度只显示 Excel 文件中的数字。',
  byYear: '按年',
  oneMonth: '单月',
  sheet: '工作表',
  legend: '2026 年 9 月及以前为 Excel 文件中的数字。自 {{from}} 起按上传的 Order Status 统计截至今天的 S/D（标 +OS；点击左侧带标记的数字可查看订单行）。',
  checkTitle: '四个产品线工作表之和 = Total Frame：',
  countedHint: '包含按 Order Status 统计的月份',
  countedCell: '其中 {{n}} 按 Order Status 统计 — 点击查看明细',
  linesYearNote: '仅显示按 Order Status 统计的部分（2026 年 10 月起）；其余为 Excel 文件中的数字。',
  model: '型号',
  color: '颜色',
  frameColor: '框架颜色',
  total: '合计',
  month: '月份',
  beforeNote: '该月早于 2026 年 10 月，Excel 文件中已有。此处为当前上传的 Order Status 的数字 — S/D 日期可能已变动。',
  none: '无出货。',
  lines: '产品线',
  year: '年份',
  dashboard: '仪表板',
  dToDate: '{{y}} 年尚未结束',
  other: '其他',
  dTotal: '出货框架',
  dTopColour: '最多的框架颜色',
  dTopModel: '最多的型号',
  dYoy: '{{a}} 对比 {{b}}',
  dByYear: '按颜色的框架，逐年（件）',
  dLatestFive: '所选年份中最近五年：{{a}} – {{b}}。',
  dTop3: '{{y}} 年前三框架颜色',
  dStack: '按颜色的框架，按型号（件，所选年份）',
  sourceShort: 'Order Status 上传于 {{at}} · S/D 至 {{to}} — 数字如何得出',
  checkOk: '四条线 = Total Frame',
  all: '全部',
  seeLines: '点击查看订单行',
  someLinesNote: '未选全四条产品线：所有年份均按上传的 Order Status（截至今天的 S/D）统计，因为 Excel 文件只有四条线合计的框架颜色。选全四条线时显示 Excel 文件的数字。',
  soFarNote: '本月尚未结束：仅统计 S/D 截至 {{d}} 的出货。Order Status 中之后的 S/D 为计划出货，不计入。',
  buyer: '买家',
  nLines: '{{n}} 行',
  loading: '加载中…',
  close: '关闭',
};

const dictionary = { ns: 'xModelColor', en, ko, vi, zh };

export default dictionary;
